import React, { useState } from 'react';

import AddColorPopUp from '@components/colors/AddColorPopUp';
import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { renderPantoneTypeColorsHorizontally, renderSwatchTypeColorsHorizontally } from '@utils/Util';

import { PANTONE_OR_HEX_CODE } from '@/constants/constant';

const AddColors = ({ productId, tagColor, onRemoveColors, colorCode, isShowRFD }) => {
	const [selectedColorList, setSelectedColorList] = useState([]);

	const onRemoveColor = async (itemId, productId) => {
		await ApiClient.POST('removeColor', [itemId], productId)
			.then(({ data }) => {
				if (data?.message) {
					const newList = selectedColorList.filter((item) => item.id !== itemId);
					setSelectedColorList(newList);
					onRemoveColors(itemId, colorCode);
					toastSuccess(data.message);
				}
			})
			.catch(({ response }) => {
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onAddNewColors = (payload) => {
		setSelectedColorList([...selectedColorList, payload]);
		tagColor(payload);
	};

	return (
		<div className="col-md-12">
			<div className="colors-row">
				<div className="d-flex align-items-center">
					<AddColorPopUp
						selectedColors={selectedColorList}
						onAddNewColors={onAddNewColors}
						productId={productId}
						addColorType={'DESIGN'}
						setOnlyColorType={true}
						showAdd={selectedColorList.length === 0}
						isShowRFD={isShowRFD}
					/>

					{selectedColorList?.map((value) =>
						value?.representedBy === PANTONE_OR_HEX_CODE
							? renderPantoneTypeColorsHorizontally(
									value,
									(itemId) => onRemoveColor(itemId, productId),
									'collections'
								)
							: renderSwatchTypeColorsHorizontally(
									value,
									(itemId) => onRemoveColor(itemId, productId),
									'collections'
								)
					)}
				</div>
			</div>
		</div>
	);
};

export default AddColors;
